import { useContext, useCallback } from 'react';
import { AuthContext } from '../context/AuthContext';
import { authService } from '../services/authService';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth deve ser usado dentro de AuthProvider');
  }
  
  // Função para limpar dados inconsistentes
  const clearInconsistentData = useCallback(() => {
    console.log('[useAuth] Limpando dados inconsistentes...');
    authService.logout();
    window.location.href = '/login';
  }, []);

  // Função para verificar organização atual
  const getCurrentOrganization = useCallback(() => {
    return context.user?.organization_id;
  }, [context.user]);

  // Função para verificar se usuário pode criar propostas
  const canCreateProposals = useCallback(() => {
    return context.user?.can_create_proposals || false;
  }, [context.user]);

  // Função para verificar se usuário é admin
  const isAdmin = useCallback(() => {
    return context.user?.user_role === 'admin' || context.user?.role === 'admin';
  }, [context.user]);

  return {
    ...context,
    clearInconsistentData,
    getCurrentOrganization,
    canCreateProposals,
    isAdmin,
  };
};
